import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var StyleIcon = function StyleIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "StyleIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.752 1.724a.78.78 0 0 0-1.104.01.783.783 0 0 0 .01 1.106l1.398 1.373-3.684 3.62a1.24 1.24 0 0 0 0 1.773l3.918 3.85c.488.48 1.273.48 1.761 0l3.918-3.85a1.24 1.24 0 0 0 0-1.773zM3.699 8.72l3.472-3.411 3.471 3.41-3.471 3.412z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      d: "M11.073 13.034c0-.463.16-.716.479-1.122l.01-.013.122-.153c.103-.13.22-.276.348-.446q.157-.206.34-.467a.202.202 0 0 1 .33 0q.181.262.339.467.194.253.348.445l.122.154.01.013c.32.406.479.659.479 1.122 0 .81-.655 1.466-1.463 1.466a1.465 1.465 0 0 1-1.464-1.466"
    })]
  }));
};

export { StyleIcon };
